<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 class="visually-hidden">
                {{ t("application.tab.disclosure") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/disclosure-icon.svg"
                        alt="disclosure-icon"
                    />
                    <h2 [innerHTML]="t('application.disclosure.header')"></h2>
                    <div id="disclosure-consent-text">
                        @if (client?.disclosureHtml1) {
                        <p
                            class="title"
                            [innerHTML]="
                                $safeNavigationMigration(
                                    client?.disclosureHtml1
                                )
                            "
                        ></p>
                        } @if (client?.disclosureHtml2) {
                        <p
                            class="title"
                            [innerHTML]="
                                $safeNavigationMigration(
                                    client?.disclosureHtml2
                                )
                            "
                        ></p>
                        }
                    </div>
                    <form
                        [formGroup]="disclosureForm"
                        (ngSubmit)="onSubmitted()"
                        fxLayout="column"
                    >
                        @if (formSections$ | async; as sections) { @for (section
                        of sections; track section; let i = $index) {
                        <div #sectionWrapper>
                            @if (isSectionVisible(section)) { @if (i > 0) {
                            <mat-divider></mat-divider>
                            } @if ( section.title || section.titleKey ||
                            section.flyoutKey ) {
                            <div class="sub-title">
                                @if ( section.title || section.titleKey ) {
                                <h3>
                                    {{
                                        t(
                                            section.titleKey ??
                                                section.title ??
                                                section.key ??
                                                ""
                                        )
                                    }}
                                </h3>
                                }
                                <app-section-flyout
                                    [flyoutKey]="section.flyoutKey"
                                    [active]="activeFlyoutIndex === i"
                                    [flipUp]="
                                        flyoutFlipUp && activeFlyoutIndex === i
                                    "
                                />
                            </div>
                            } @if ( section.description ||
                            section.descriptionKey ) {
                            <p>
                                {{
                                    t(
                                        section.descriptionKey ??
                                            section.description ??
                                            ""
                                    )
                                }}
                            </p>
                            } @for (row of section.rows; track row) {
                            <div>
                                <app-dynamic-form
                                    [formGroup]="disclosureForm"
                                    [fields]="row.fields"
                                    [formSubmitted]="submitted"
                                    [sectionValidators]="
                                        getSectionValidators(section)
                                    "
                                    [consentDescribedById]="
                                        'disclosure-consent-text'
                                    "
                                >
                                </app-dynamic-form>
                            </div>
                            } @for ( validator of getSectionErrors( section ) ;
                            track validator.errorKey ?? validator.name) {
                            <mat-error>
                                {{
                                    t(
                                        validator.messageKey ??
                                            validator.message ??
                                            validator.name
                                    ) ??
                                        validator.messageKey ??
                                        validator.message
                                }}
                            </mat-error>
                            } }
                        </div>
                        } }

                        <button
                            mat-stroked-button
                            class="submit"
                            type="submit"
                            [disabled]="submitting"
                        >
                            {{ t("application.submit-applications") }}
                        </button>
                        @if (client?.disclosureTermsFooterHtml) {
                        <div
                            class="terms-footer"
                            [innerHTML]="
                                $safeNavigationMigration(
                                    client?.disclosureTermsFooterHtml
                                )
                            "
                        ></div>
                        }
                    </form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            >
                <mat-card appearance="outlined"> </mat-card>
            </div>
        </div>
    </div>
</ng-container>
